import {
  SHRIFT_SET_CONNECTION,
  SHRIFT_CLEAR_PARTICIPANTS,
  SHRIFT_ADD_PARTICIPANT,
  SHRIFT_REMOVE_PARTICIPANT,
  SHRIFT_SET_VIDEO_DEVICE,
  SHRIFT_SET_AUDIO_DEVICE,
  SHRIFT_SET_STATUS,
  SHRIFT_SET_PARTICIPANT_STATUS,
  SHRIFT_SET_ALL_PARTICIPANTS_OFFLINE,
  SHRIFT_CLEAR_MESSAGES,
  SHRIFT_SET_MESSAGES, SHRIFT_ADD_MESSAGE, SHRIFT_SET_PRIEST_ON_SHRIFT
} from './mutations'

import Shrift from '@/utils/shrift'

export default {
  async connectToWebSocket ({ commit, state, dispatch }, user) {
    if (state.connection) {
      return
    }

    const connection = new Shrift((e) => {
      const response = JSON.parse(e.data)
      if (response.category !== 'shrift') {
        return
      }
      switch (response.type) {
        case 'event':
          switch (response.event) {
            case 'participant-join':
              commit(SHRIFT_ADD_PARTICIPANT, response['participant'])
              break
            case 'participant-leave':
              commit(SHRIFT_REMOVE_PARTICIPANT, response['participant'])
              break
            case 'participant-status':
              commit(SHRIFT_SET_PARTICIPANT_STATUS, { participant: response['participant'], online: true })
              break
            case 'priest-on-shrift':
              commit(SHRIFT_SET_PRIEST_ON_SHRIFT, response['busy'])
              break
            case 'message':
              commit(SHRIFT_ADD_MESSAGE, response['message'])
          }
          break
        case 'participants':
          commit(SHRIFT_CLEAR_PARTICIPANTS)
          Object.values(response.participants).forEach(participant => {
            commit(SHRIFT_ADD_PARTICIPANT, participant)
          })
          break
        case 'messages':
          commit(SHRIFT_SET_MESSAGES, response.messages)
          break
        default:
          console.log(response)
      }
    })

    await connection.connect()

    commit(SHRIFT_SET_CONNECTION, connection)
    commit(SHRIFT_SET_STATUS, !!connection)
  },
  async disconnectFromWebSocket ({ commit, state, rootState }, parish) {
    if (!state.connection) {
      return
    }

    console.log('disconnection')

    try {
      const action = 'leave'
      await state.connection.send({
        action,
        parish: {
          id: parish.id
        },
        token: rootState.AuthModule.token
      })

      state.connection.disconnect()
    } catch (error) {
      throw new Error(error.message)
    }

    commit(SHRIFT_SET_CONNECTION, null)
    commit(SHRIFT_SET_STATUS, false)
    commit(SHRIFT_CLEAR_MESSAGES)
  },
  join: ({ state, dispatch, rootState }, parish) => {
    if (!state.connected) {
      throw new Error('Not connected to WS')
    }

    const action = 'join'
    state.connection.send({
      action,
      parish: {
        id: parish.id
      },
      token: rootState.AuthModule.token
    })
  },
  online: ({ state, rootState, commit }, parish) => {
    if (!state.connected) {
      throw new Error('Not connected to WS')
    }

    const action = 'online'
    state.connection.send({
      action,
      parish: {
        id: parish.id
      },
      token: rootState.AuthModule.token
    })

    commit(SHRIFT_SET_PARTICIPANT_STATUS, { participant: { id: rootState.UserModule.id }, online: true })
  },
  setPriestOnShrift ({ state, rootState, commit }, parish) {
    if (!state.connected) {
      throw new Error('Not connected to WS')
    }

    const action = 'priest_on_shrift'
    state.connection.send({
      action,
      status: true,
      parish: {
        id: parish.id
      },
      token: rootState.AuthModule.token
    })
  },
  setPriestOffShrift ({ state, rootState, commit }, parish) {
    if (!state.connected) {
      throw new Error('Not connected to WS')
    }

    const action = 'priest_on_shrift'
    state.connection.send({
      action,
      status: false,
      parish: {
        id: parish.id
      },
      token: rootState.AuthModule.token
    })
  },
  clear ({ dispatch }) {
    dispatch('setDevices', { video: null, audio: null })
  },
  setDevices ({ commit }, { video, audio }) {
    commit(SHRIFT_SET_VIDEO_DEVICE, video)
    commit(SHRIFT_SET_AUDIO_DEVICE, audio)
  },

  setAllUsersOffline ({ commit }) {
    commit(SHRIFT_SET_ALL_PARTICIPANTS_OFFLINE)
  },
  setUserOnline ({ commit }, user) {
    commit(SHRIFT_SET_PARTICIPANT_STATUS, { participant: user, online: true })
  },
  sendMessageToChat ({ commit, state, rootState }, { message, parish }) {
    try {
      const action = 'message'
      state.connection.send({
        action,
        parish: {
          id: parish.id
        },
        message,
        token: rootState.AuthModule.token
      })
    } catch (error) {
      throw new Error(error.message)
    }
  }
}
